import React from 'react';
import { Link } from 'react-router-dom';


const SplashCta = () => {
    return (
        <div className="section call-to-action-area splash-call-to-action">
            <div className="container">
                <div className="call-to-action">
                <div className="section-heading heading-light">
                    <div className="title" style={{ fontSize: "var(--h2)" }}>Let’s Start <br /> Your Project Today!</div>
                    <p>Just tell us what you need by contacting us. Our team is ready to comply to your needs.</p>
                    <Link to="/contact" className="axil-btn btn-fill-white">Contact Us</Link>
                </div>
                </div>
            </div>
            <ul className="list-unstyled shape-group-9">
                <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/bubble-12.png"}  alt="shape"/></li>
                <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/bubble-16.png"}  alt="shape"/></li>
                <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/bubble-13.png"}  alt="shape"/></li>
                <li className="shape shape-4"><img src={process.env.PUBLIC_URL + "/images/others/bubble-14.png"}  alt="shape"/></li>
                <li className="shape shape-5"><img src={process.env.PUBLIC_URL + "/images/others/bubble-16.png"}  alt="shape"/></li>
                <li className="shape shape-6"><img src={process.env.PUBLIC_URL + "/images/others/bubble-15.png"}  alt="shape"/></li>
                <li className="shape shape-7"><img src={process.env.PUBLIC_URL + "/images/others/bubble-16.png"}  alt="shape"/></li>
            </ul>
        </div>
    )
}

export default SplashCta;